export default __webpack_public_path__ + "static/media/rating_7.d6a0ecd1.png";